module.exports = __webpack_public_path__ + "img/CZ60197609.bdc04729.png";